import React from 'react';
import { MediaPlayer, MediaProvider } from '@vidstack/react';
import { defaultLayoutIcons, DefaultVideoLayout } from '@vidstack/react/player/layouts/default';
import '@vidstack/react/player/styles/default/theme.css';
import '@vidstack/react/player/styles/default/layouts/video.css';

// Plays a meeting recording from a (presigned) URL using @vidstack/react.
// The recording is ffmpeg-remuxed on upload so it has a real duration →
// streamType="on-demand" makes it a normal seekable VOD (no LIVE badge). We pass
// no title, so the player shows no "Meeting recording" overlay text. `playerRef`
// lets a parent subscribe to time updates / seek (used by the synced transcript).
export default function RecordingPlayer({ src, playerRef, className = '' }) {
    if (!src) return null;
    return (
        <div data-testid="recording-player" className={`rounded-xl overflow-hidden bg-black ${className}`}>
            <MediaPlayer
                ref={playerRef}
                title=""
                src={src}
                viewType="video"
                streamType="on-demand"
                playsInline
                aspectRatio="16/9"
            >
                <MediaProvider />
                <DefaultVideoLayout icons={defaultLayoutIcons} />
            </MediaPlayer>
        </div>
    );
}
